import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[optionLabelDirective]',
  exportAs: 'optionLabelDirective'
})
export class OptionLabelDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
